import { alpha, Theme } from '@mui/material';
import { SUBSCRIPTION_STATUS, STATUS_LABEL } from './constants';
import { Subscription } from './hooks/useMarketplaceSubscriptions';

const SubscriptionHelper = {
    getStatusLabel: (subscription: Subscription): string => {
        if (subscription.isTrial) return '7 DAYS FREE!';
        return STATUS_LABEL[subscription.status] ?? '';
    },

    getChipColor: (subscription: Subscription, theme: Theme): { backgroundColor: string; color: string } => {
        if (subscription.isTrial) return {
            backgroundColor: theme.palette.secondary.dark,
            color: theme.palette.highlighter.yellow
        };

        switch (subscription.status) {
            case SUBSCRIPTION_STATUS.ACTIVE:
                return { backgroundColor: alpha(theme.palette.success.main, 0.12), color: theme.palette.success.main };
            case SUBSCRIPTION_STATUS.OVERDUE:
                return { backgroundColor: alpha(theme.palette.warning.main, 0.12), color: theme.palette.warning.main };
            case SUBSCRIPTION_STATUS.CANCEL_PENDING:
                return { backgroundColor: alpha(theme.palette.error.main, 0.12), color: theme.palette.error.dark };
            default:
                return { backgroundColor: theme.palette.action.disabledBackground, color: theme.palette.text.disabled };
        }
    },

    parseDate: (date: string): Date | null => {
        if (!date || date === '0000-00-00 00:00:00') return null;
        const normalized = date.replace(/(.+) (.+)/, '$1T$2');
        const formattedDate = new Date(normalized);
        return Number.isNaN(formattedDate.getTime()) ? null : formattedDate;
    },

    getRenewalText: (status: number, nextBillingDate: string, isTrial: boolean, isProgram: boolean): string => {
        if (isProgram) return 'Lifetime Access';
        const parsedNextBillingDate = SubscriptionHelper.parseDate(nextBillingDate);
        if (!parsedNextBillingDate) return '';
        const formattedNextBillingDate = parsedNextBillingDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        if (status === SUBSCRIPTION_STATUS.CANCEL_PENDING) return `${isTrial ? 'Trial' : 'Subscription'} ends ${formattedNextBillingDate}`;
        if (status === SUBSCRIPTION_STATUS.OVERDUE) {
            const diffDays = Math.floor((Date.now() - parsedNextBillingDate.getTime()) / (1000 * 60 * 60 * 24));
            return diffDays <= 0 ? 'Due today' : `Due ${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
        }
        return `${isTrial ? 'Starting' : 'Renews'} ${formattedNextBillingDate}`;
    }
};

export default SubscriptionHelper;
